import React, { useState, createContext, useContext } from 'react';
export type Lang = 'en' | 'hr';
const translations = {
  en: {
    // Hero
    heroOverline: 'Portfolio',
    heroTitle1: 'Developing digital',
    heroTitle2: 'products with craft.',
    heroSubtitle: 'Developer focused on beautiful, performant web experiences with meticulous attention to detail.',
    heroStat1Value: '15+',
    heroStat1Label: 'Projects Delivered in 2025',
    heroStat2Value: '6+',
    heroStat2Label: 'Years Experience',
    heroStat3Value: '8',
    heroStat3Label: 'Services Offered',
    heroScroll: 'Scroll to explore',
    // Marquee
    marqueeText: 'Design · Develop · Deploy · ',
    // Projects
    projectsOverline: 'Selected Work',
    projectsTitle: 'Recent projects',
    projectsTotal: 'total recent projects',
    projectsViewAll: 'View All',
    projectsProjects: 'Projects',
    projectsAllProjects: 'All Projects',
    // Categories
    catAll: 'All',
    catBrandIdentity: 'Brand Identity',
    catEcommerce: 'eCommerce',
    catBooking: 'Booking',
    catRentCar: 'Rent a Car',
    catRentBoat: 'Rent a Boat',
    catCustom: 'Custom-Special',
    // About
    aboutOverline: 'About',
    aboutTitle: 'Smooth digital operator.',
    aboutP1: 'I believe the best digital products come from obsessive attention to detail — in both how they look and how they work. Every project is an opportunity to create something that feels considered and intentional.',
    aboutP2: 'With over six years of experience shipping products, I bring a deep understanding of modern web technologies and a relentless focus on craft.',
    aboutP3: "I've worked as a team lead in an agency environment, and I also take on solo projects where I handle everything from initial design to final development and deployment.",
    servicesOverline: 'Services',
    svcWebDev: 'Web Development',
    svcEcommerce: 'eCommerce Solutions',
    svcAI: 'AI Integrations',
    svcMonthly: 'Monthly Website Management',
    svcDomain: 'Domain & Hosting Management',
    svcEmail: 'Email Setup',
    svcPerformance: 'Performance Optimization',
    svcSEO: 'SEO',
    // Crobot
    crobotOverline: 'Personal Project · Founder',
    crobotTitle: 'Personal Project - Crobot.ai',
    crobotDesc: "A personal passion project — Croatia's first AI chatbot platform, built entirely from scratch. From concept to marketing, I grew Crobot to 700+ active members, earning recognition from Croatia's leading business platform Lider Media.",
    crobotDetail: "What started as a side project became Croatia's first custom AI chatbot — advanced conversational AI with community features and scalable architecture. I handled everything: development, design, marketing, and growth. The project's success led to a feature interview by Lider Media, Croatia's premier business publication.",
    crobotStat1: 'Members',
    crobotStat2: 'Croatian AI Chatbot',
    crobotStat3: 'Solo Built',
    // Press
    pressOverline: 'Press Recognition',
    pressTitle1: 'Featured in Global Platforms &',
    pressTitle2: 'Croatian Premier Business Media',
    pressDesc: "Recognized by Lider Media — Croatia's leading business platform — for AI-powered business solutions and web development, and by Elementor (elementor.com) for performance optimization work.",
    pressArticle1Title: "Who's Behind CroBot — Croatia's New AI Chatbot",
    pressArticle1Desc: 'Featured for developing CroBot, an AI-powered chatbot built for Croatian businesses, showcasing conversational AI and natural language processing.',
    pressArticle2Title: "Morning Chat with Crobot, Croatia's First AI Platform",
    pressArticle2Desc: "An exclusive interview detailing the development, capabilities, and future of Crobot, Croatia's pioneering AI platform.",
    pressArticle3Title: 'Image Optimizer Case Study',
    pressArticle3Desc: 'Recognized by Elementor for strong speed optimization results, demonstrating solid performance techniques in modern web development.',
    // Contact
    contactOverline: 'Get in touch',
    contactTitle1: 'Have a project',
    contactTitle2: 'in mind?',
    contactSubtitle: "I'd love to hear about it. Let's discuss how we can work together to bring your vision to life.",
    contactEmail: 'Email',
    contactPhone: 'Phone',
    contactWhatsApp: 'WhatsApp',
    contactWhatsAppCTA: "Let's talk on WhatsApp now!",
    contactAvailable: 'Available for new projects',
    contactFooterLocation: 'Designed & developed in Zagreb, Croatia',
    // Contact Widget
    widgetCTA: "Let's Talk",
    widgetTitle1: "Let's build",
    widgetTitle2: 'something great.',
    widgetDesc: "Whether you need a new website, an e-commerce platform, or a custom web solution — I'm here to help bring your vision to life.",
    widgetBased: 'Based in Zagreb, Croatia',
    // Preloader
    preloaderWord1: 'Smooth',
    preloaderWord2: 'Operator',
    preloaderTagline: 'Digital products with craft'
  },
  hr: {
    // Hero
    heroOverline: 'Portfolio',
    heroTitle1: 'Razvijam digitalne',
    heroTitle2: 'proizvode s pažnjom.',
    heroSubtitle: 'Developer fokusiran na lijepa, brza web iskustva s pedantnom pažnjom na detalje.',
    heroStat1Value: '15+',
    heroStat1Label: 'Projekata u 2025.',
    heroStat2Value: '6+',
    heroStat2Label: 'Godina iskustva',
    heroStat3Value: '8',
    heroStat3Label: 'Usluga u ponudi',
    heroScroll: 'Pomakni za više',
    // Marquee
    marqueeText: 'Dizajn · Razvoj · Objava · ',
    // Projects
    projectsOverline: 'Odabrani radovi',
    projectsTitle: 'Nedavni projekti',
    projectsTotal: 'ukupno nedavnih projekata',
    projectsViewAll: 'Pogledaj sve',
    projectsProjects: 'Projekata',
    projectsAllProjects: 'Svi projekti',
    // Categories
    catAll: 'Sve',
    catBrandIdentity: 'Brend identitet',
    catEcommerce: 'eCommerce',
    catBooking: 'Rezervacije',
    catRentCar: 'Rent a Car',
    catRentBoat: 'Rent a Boat',
    catCustom: 'Custom-Special',
    // About
    aboutOverline: 'O meni',
    aboutTitle: 'Pišem kod onako kako drugi stvaraju umjetnost.',
    aboutP1: 'Vjerujem da najbolji digitalni proizvodi nastaju iz opsesivne pažnje na detalje — i u izgledu i u funkcionalnosti. Svaki projekt je prilika za stvaranje nečeg promišljenog i namjernog.',
    aboutP2: 'S više od šest godina iskustva u isporuci proizvoda, donosim duboko razumijevanje modernih web tehnologija i neumoljiv fokus na kvalitetu.',
    aboutP3: 'Radio sam kao voditelj tima u agencijskom okruženju, a također preuzimam i samostalne projekte gdje se brinem o svemu — od inicijalnog dizajna do završnog razvoja i objave.',
    servicesOverline: 'Usluge',
    svcWebDev: 'Web razvoj',
    svcEcommerce: 'eCommerce rješenja',
    svcAI: 'AI integracije',
    svcMonthly: 'Mjesečno upravljanje web stranicom',
    svcDomain: 'Upravljanje domenom i hostingom',
    svcEmail: 'Postavljanje e-pošte',
    svcPerformance: 'Optimizacija performansi',
    svcSEO: 'SEO',
    // Crobot
    crobotOverline: 'Osobni projekt · Osnivač',
    crobotTitle: 'Osobni projekt - Crobot.ai',
    crobotDesc: 'Osobni projekt iz strasti — prva hrvatska AI chatbot platforma, izgrađena potpuno od nule. Od koncepta do marketinga, Crobot je narastao na 700+ aktivnih članova, zaslužujući priznanje od vodeće hrvatske poslovne platforme Lider Media.',
    crobotDetail: 'Ono što je počelo kao sporedni projekt postalo je prvi hrvatski prilagođeni AI chatbot — napredna konverzacijska AI s funkcijama zajednice i skalabilnom arhitekturom. Brinuo sam se o svemu: razvoju, dizajnu, marketingu i rastu. Uspjeh projekta doveo je do intervjua u Lider Mediji, vodećoj hrvatskoj poslovnoj publikaciji.',
    crobotStat1: 'Članova',
    crobotStat2: 'Hrvatski AI Chatbot',
    crobotStat3: 'Samostalno izgrađen',
    // Press
    pressOverline: 'Medijsko priznanje',
    pressTitle1: 'Predstavljen na globalnim platformama i',
    pressTitle2: 'vodećim hrvatskim poslovnim medijima',
    pressDesc: 'Prepoznat od strane Lider Medije — vodeće hrvatske poslovne platforme — za AI poslovna rješenja i web razvoj, te od strane Elementora za optimizaciju performansi.',
    pressArticle1Title: 'Tko se krije iza CroBota — novog hrvatskog AI chatbota',
    pressArticle1Desc: 'Predstavljen za razvoj CroBota, AI chatbot rješenja za hrvatske tvrtke, s fokusom na konverzacijsku AI i obradu prirodnog jezika.',
    pressArticle2Title: 'Jutarnji razgovor s Crobotom, prvom hrvatskom AI platformom',
    pressArticle2Desc: 'Ekskluzivni intervju koji detaljno opisuje razvoj, mogućnosti i budućnost Crobota, pionirske hrvatske AI platforme.',
    pressArticle3Title: 'Studija slučaja optimizacije slika',
    pressArticle3Desc: 'Prepoznat od strane Elementora za dobre rezultate optimizacije brzine, prikazujući solidne tehnike u modernom web razvoju.',
    // Contact
    contactOverline: 'Kontakt',
    contactTitle1: 'Imate projekt',
    contactTitle2: 'na umu?',
    contactSubtitle: 'Rado bih čuo o tome. Razgovarajmo kako možemo zajedno ostvariti vašu viziju.',
    contactEmail: 'E-pošta',
    contactPhone: 'Telefon',
    contactWhatsApp: 'WhatsApp',
    contactWhatsAppCTA: 'Razgovarajmo na WhatsAppu!',
    contactAvailable: 'Dostupan za nove projekte',
    contactFooterLocation: 'Dizajnirano i razvijeno u Zagrebu, Hrvatska',
    // Contact Widget
    widgetCTA: 'Kontakt',
    widgetTitle1: 'Izgradimo',
    widgetTitle2: 'nešto sjajno.',
    widgetDesc: 'Trebate li novu web stranicu, e-commerce platformu ili prilagođeno web rješenje — tu sam da pomognem ostvariti vašu viziju.',
    widgetBased: 'Sjedište u Zagrebu, Hrvatska',
    // Preloader
    preloaderWord1: 'Smooth',
    preloaderWord2: 'Operator',
    preloaderTagline: 'Digitalni proizvodi s pažnjom'
  }
} as const;
export type Translations = (typeof translations)['en'];
interface LanguageContextType {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: Translations;
}
const LanguageContext = createContext<LanguageContextType>({
  lang: 'en',
  setLang: () => {},
  t: translations.en
});
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [lang, setLang] = useState<Lang>('en');
  const t = translations[lang];
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-376">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  return useContext(LanguageContext);
}